/*
 * Copyright (C) 2016 - 2024 Vivien Pelenc / CEFE / CNRS
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https:www.gnu.org/licenses/>.
 */

import React, {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import "./styles.css";
import ChartAirHumidityAndTemperature from "./chart/ChartAirHumidityAndTemperature";
import DonneeInstantanee from "./DonneeInstantanee/DonneeInstantanee";
import ChartCumulDynamique from "./chart/ChartCumulDynamique";
import ChartPressure from "./chart/ChartPressureAndSolar";
import ChartCumulDynamiqueTotal from "./chart/ChartCumulDynamiqueTotal";
import {getDonneTelechargementDate} from "./ConnectionBDD";
import TelechargementDonneeNew from "./TelechargementDonneeNew";
import TelechargementDonneeOld from "./TelechargementDonneeOld";
import ChartRadarWind from "./chart/ChartRadarWind";
import ChartSoilHumidityAndTemperature from "./chart/ChartSoilHumidityAndTemperature";
import Map from "./chart/Map";


const root = createRoot(document.getElementById("root"));
root.render(
    <StrictMode>
        <div className="long">
            <DonneeInstantanee/>
        </div>

        <div className="container">


            <div className="line">
                <ChartAirHumidityAndTemperature/>
            </div>

            <div className="line">
                <ChartPressure/>
            </div>

            <div className="cumul">
                <ChartCumulDynamique/>
            </div>

            <div className="cumul">
                <ChartCumulDynamiqueTotal/>
            </div>

            <div className="line">
                <ChartSoilHumidityAndTemperature/>
            </div>

            <div className="line">
                <ChartRadarWind/>
            </div>

            <div className="cumul">
                <Map/>
            </div>
        </div>


    </StrictMode>
);

function showElementP(id) {
    const element = document.getElementById("conditions-text");
    const element2 = document.getElementById("description-text");

    const btn1 = document.getElementById("btn-conditions");
    const btn2 = document.getElementById("btn-description");

    if (id === "conditions-text") {
        element.style.display = "block";
        element2.style.display = "none";
        btn1.style.textDecoration = "underline";
        btn2.style.textDecoration = "none";
    }
    if (id === "description-text") {
        element2.style.display = "block";
        element.style.display = "none";
        btn2.style.textDecoration = "underline";
        btn1.style.textDecoration = "none";
    }
}


const dataDisplay = createRoot(document.getElementById("dataDisplay"));
dataDisplay.render(
    <StrictMode>
        <div id="telechagement">
            <TelechargementDonneeOld/>
            <TelechargementDonneeNew/>
        </div>
        <div id="conditions">
        <div className="box">
            <h3>Conditions d'Utilisation</h3>
            <div>
                <div>
                    <strong
                        id="btn-conditions"
                        style={{color:"rgb(8, 170, 3)", cursor:"pointer", textDecoration: "underline"}}
                        className="section-title"
                        onClick={() => showElementP("conditions-text")}
                    >
                        Règles d'Utilisation des Données
                    </strong>

                    <strong
                        id="btn-description"
                        style={{paddingLeft:20, color:"rgb(8, 170, 3)", cursor:"pointer"}}
                        className="section-title"
                        onClick={() => showElementP("description-text")}
                    >
                        Description des variables
                    </strong>
                </div>

            </div>
            <div id="conditions-text">
                <p>Les utilisateurs devront faire figurer la mention <em>"Source des données : Plateforme des Terrains d'expériences du CEFE-UMR 5175, CNRS."</em>, sur tout document et/ou produit et/ou service quelle que soit sa nature (publication scientifique, articles journalistiques, statistiques, etc.), et quelle que soit sa forme (physique, audiovisuelle, électronique, etc.) ayant pour origine l’utilisation totale ou partielle de ces données.</p>
                <p>L’exploitation des données est autorisée à condition qu’il ne s’agisse pas d’une utilisation commerciale. Les utilisations commerciales restent soumises à l'autorisation de la Direction du CEFE (Centre d’Ecologie Fonctionnelle et Evolutive – UMR 5175), tutelle légale de la plateforme des Terrains d'expériences.</p>

                <strong className="section-title">--- Responsabilité et Engagement sur la Qualité des Données ---</strong>
                <p>En dépit des efforts mis en oeuvre pour en vérifier la fiabilité, le fournisseur n'est pas en mesure de garantir que les données sont exemptes d'erreurs, notamment d'imprécisions.</p>
                <p>En conséquence, les utilisateurs utilisent les données sous leur responsabilité pleine et entière.</p>
                <p className="contact">Pour toute information supplémentaire, contacter la plateforme Terrain d'expériences du CEFE (courriel : pfTE@cefe.cnrs.fr)</p>

                <strong className="section-title">--- Protection des Données Personnelles ---</strong>
                <p>Les données personnelles éventuellement collectées ne sont ni distribuées, ni vendues, ni traitées à des fins commerciales. Elles sont utilisées uniquement à des fins statistiques, dans le respect de la confidentialité et de la réglementation en vigueur.</p>
            </div>


            <div id="description-text" style={{display: 'none'}}>
                <h2>DONNEES JOURNALIERES DE 1968 à 2013</h2>

                <h3>Caractéristiques :</h3>
                <ul>
                    <li>Données relevées manuellement sur la station des Terrains d'Expériences du CEFE, Montpellier.</li>
                    <li>Emplacement : Champ ouvert, terrain enherbé.</li>
                    <li>Matériels : Thermomètre à maxima, thermomètre à minima et thermographe dans un abri homologué Météo France, pluviographe, pluviomètre à lecture directe SPIEA homologué Météo France.</li>
                    <li>Archives/classement : Les bandes papier des thermographe et pluviographe, ainsi que l’humidité sont rangées, classées et archivées à la plateforme.
                        <p>Années disponibles : Thermo : 1969 à 2012 ; Pluvio : 1991 à 2010 ; Humidité : 1969 à 1978.</p>
                            <p>La consultation ne peut se faire que sur place, et est soumise à autorisation expresse de la plateforme.</p>
                    </li>
                </ul>

                <h3>Variables relevées :</h3>
                <ul>
                    <li>DATE_RELEVE : date (jj/mm/aaaa)</li>
                    <li>TEMP_MIN : température minimale (en °C)</li>
                    <li>TEMP_MAX : température maximale (en °C)</li>
                    <li>PRECIP_CUMUL : cumul des précipitations du jour (en mm)</li>
                </ul>

                <p><strong>IMPORTANT :</strong> Les données téléchargées ici concernent uniquement la température minimum, la température maximum et le cumul de pluie journaliers.</p>


                <h2>DONNEES JOURNALIERES DE 2014 à aujourd'hui</h2>

                <h3>Caractéristiques :</h3>
                <ul>
                    <li>Données mesurées et/ou calculées à partir des relevés automatiques (fréquence 30 minutes) de la station Davis VantagePro2 installée sur les Terrains d'Expériences du CEFE, Montpellier.</li>
                    <li>Emplacement : Champ ouvert, terrain enherbé et clôturé.</li>
                    <li>Matériel :
                        <ul>
                            <li>Station météo Vantage Pro 2 Plus sans fil avec ventilation active. Sur trépied inox de 3 mètres.</li>
                            <li>Tous capteurs d’origine</li>
                            <li>Capteurs additionnels : Sonde de température Inox 6475 et sonde watermark 6440 pour mesure de température et teneur en eau du sol, enterrées à une profondeur de 40 cm.</li>
                            <li>Pluviomètre à augets basculants 7852 déporté (surface de réception : 214 cm²).</li>
                            <li>Pluviomètre à lecture directe SPIEA homologué Météo France pour mesure étalon (Surface de réception : 400 cm²).</li>
                        </ul>
                        Les deux pluviomètres ci-avant sont disposés dans les mêmes conditions, à savoir en champ ouvert, et surface de réception à 1,5 m. au-dessus du sol.
                    </li>
                </ul>

                <h3>Variables mesurées et calculées :</h3>
                <ul>
                    <li>DATE_RELEVE : date (jj/mm/aaaa)</li>
                    <li>TEMP_MOY(*) : moyenne des températures (en °C)</li>
                    <li>TEMP_MIN : température minimale (en °C)</li>
                    <li>TEMP_MAX : température maximale (en °C)</li>
                    <li>PRESSION_MOY(*) : moyenne des pressions atmosphériques (en hPa)</li>
                    <li>PRESSION_MIN(*) : pression atmosphérique minimale (en hPa)</li>
                    <li>PRESSION_MAX(*) : pression atmosphérique maximale (en hPa)</li>
                    <li>VENT_VITESSE_MOY(*) : moyenne des vitesses du vent (en km/h)</li>
                    <li>VENT_VITESSE_MAX(*) : vitesse maximale du vent enregistrée (en km/h)</li>
                    <li>PRECIP_CUMUL : cumul des précipitations du jour (en mm)</li>
                    <li>HUM_MOY(*) : moyenne de l'humidité (en %)</li>
                    <li>HUM_MIN(*) : humidité minimale (en %)</li>
                    <li>HUM_MAX(*) : humidité maximale (en %)</li>
                    <li>RAY_SOL_MAX(*) : radiation solaire maximale (W/m²)</li>
                    <li>ET_CUMUL(*) : cumul évapotranspiration (mm)</li>
                    <li>Temp. Sol : moyenne des températures (en °C)</li>
                    <li>Teneur en eau du sol : ? (en cbars)</li>
                </ul>


                <h2>DONNEES INFRA-HORAIRES DE 2014 à aujourd'hui</h2>

                <h3>Caractéristiques :</h3>
                <ul>
                    <li>Relevés automatiques 30 minutes de la station automatique.</li>
                </ul>

                <h3>Variables mesurées et calculées :</h3>
                <p>Identiques aux variables journalières de 2014 à aujourd'hui (voir ci-dessus) mais avec une précision plus importante sur un pas de 30 minutes pour plusieurs valeurs (Température, humidité, pluie…), valeurs auxquelles il faut ajouter :</p>
                <ul>
                    <li>UV</li>
                    <li>Point de rosée</li>
                    <li>Direction du vent</li>
                    <li>Indice de chaleur</li>
                    <li>THW</li>
                    <li>THSW</li>
                    <li>Indice de refroidissement éolien</li>
                    <li>Intensité de précipitations</li>
                </ul>

                <p>Pour obtenir les données infra-horaires ou pour toute information supplémentaire, envoyez un courriel à la plateforme des Terrains d'expériences du CEFE (<em>pfTE *AT* cefe.cnrs.fr</em>).</p>

            </div>
        </div>
        </div>
    </StrictMode>
);






